import { IDealsInfo } from "features/Deals/interfaces";
import { apiClient } from "lib/apiClient";

export const getAllDeals = async (status = "ACTIVE"): Promise<IDealsInfo> => {
  const response = await apiClient.get(`/deals?status=${status}`);

  return response.data;
};
